(function () {
  function isExcludedPath(pathname) {
    var excluded = [
      '/collections/monthly-hot-wheels-subscription-club-boxes',
      '/cart',
      '/checkout',
      '/checkouts',
      '/account',
      '/account/login',
      '/account/register',
      '/orders',
      '/thank_you',
      '/policies'
    ];

    return excluded.some(function (path) {
      return pathname.indexOf(path) === 0;
    });
  }

  function pushEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      campaign_id: 'mm_subscription_floating_tab_v1',
      page_path: window.location.pathname,
      destination_url: payload && payload.destination_url ? payload.destination_url : undefined
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var tab = document.querySelector('[data-mm-subscription-floating-tab]');

    if (!tab) return;

    if (!tab.closest('[data-mm-r32-collector-dock]') && isExcludedPath(window.location.pathname)) {
      tab.remove();
      return;
    }

    tab.addEventListener('click', function () {
      pushEvent('mm_subscription_floating_tab_click', {
        destination_url: tab.href
      });
    });

    pushEvent('mm_subscription_floating_tab_view');
  });
})();
